import styled from 'styled-components';

import AccessGuard from 'components/shared/AccessGuard';
import Checkbox from 'components/shared/form/Checkbox';
import Episode from 'models/Episode';
import LocationEpisode from 'models/LocationEpisode';
import { Permission } from 'models/Profile';
import { colors } from 'styles/theme/colors';

import { ActivityInputValues } from './useActivityInput';

type PriorityEscalationCheckboxProps = {
  permission: Permission;
  label: string;
  values: ActivityInputValues;
  setValues: React.Dispatch<React.SetStateAction<ActivityInputValues>>;
  locationEpisode: LocationEpisode;
  episode: Episode;
};

const PriorityEscalationCheckbox = ({
  permission,
  label,
  values,
  setValues,
  locationEpisode,
  episode,
}: PriorityEscalationCheckboxProps) => {
  return (
    <AccessGuard accessor={permission} locationEpisode={locationEpisode} episode={episode}>
      <EscalateActions $darkBorder={false}>
        <Checkbox
          checked={values.escalated || false}
          checkedColor={colors.red100}
          size={14}
          labelSize='12px'
          label={label}
          onChange={() => setValues((prev) => ({ ...prev, escalated: !prev.escalated }))}
        />
      </EscalateActions>
    </AccessGuard>
  );
};

export default PriorityEscalationCheckbox;

const EscalateActions = styled.div<{ $darkBorder: boolean }>`
  display: flex;
  align-items: center;
  cursor: pointer;
  user-select: none;
  border-left: 1px solid ${({ $darkBorder }) => ($darkBorder ? 'var(--black-25)' : 'var(--black-10)')};
  padding: 4px 0px 4px 16px;
  gap: 10px;
`;
